import React, { useEffect, useState } from "react"

import { useEventBus } from "@cirrus/core/events"

import { InfoDialog } from "./index"
import { IProctorioObserverEvent } from "../event"

export const ObserverInfoDialog = () => {
  const bus = useEventBus<IProctorioObserverEvent>()
  const [content, setContent] = useState<string>("")

  useEffect(() => {
    return bus.on("ProctorioObserver > Dialog > Open", ({ content }) => {
      setContent(content)
    })
  }, [])

  useEffect(() => {
    return bus.on("ProctorioObserver > Dialog > Close", () => {
      setContent("")
    })
  }, [])

  return <InfoDialog open={!!content} content={content} />
}
